import { Link, useLocation } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import { Seo } from "@/components/base/Seo";

export default function NotFound() {
  const location = useLocation();

  return (
    <Layout>
      <Seo
        title="页面不存在 - 17爆料网"
        description="你访问的页面不存在或已被移除，可返回首页或前往真假鉴定专区继续浏览。"
        keywords="17爆料网,页面不存在"
        path={location.pathname}
      />
      <div className="mx-auto flex w-full max-w-3xl flex-col items-center px-4 py-24 text-center md:px-8">
        <p className="font-label text-7xl font-600 text-primary-300 md:text-9xl">404</p>
        <h1 className="mt-6 font-heading text-2xl font-700 text-foreground-950 md:text-3xl">这条内容没找到</h1>
        <p className="mt-3 text-sm text-foreground-600 md:text-base">
          页面可能已下线或被更正。你可以回到首页，或直接进入真假鉴定专区继续浏览。
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-500 text-background-50 transition-colors hover:bg-primary-600"
          >
            返回首页
          </Link>
          <Link
            to="/verify"
            className="whitespace-nowrap rounded-md border border-background-300 px-6 py-2.5 text-sm font-500 text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            进入鉴定专区
          </Link>
        </div>
      </div>
    </Layout>
  );
}